const IPA_TO_LATIN: Record<string, string> = {
  // Vowels.
  a: 'a',
  ɑ: 'a',
  e: 'e',
  ɛ: 'e',
  æ: 'ae',
  ɐ: 'a',
  ɒ: 'o',
  ɔ: 'o',
  i: 'i',
  ɪ: 'i',
  ɨ: 'y',
  ʉ: 'u',
  ɘ: 'e',
  ɵ: 'o',
  o: 'o',
  u: 'u',
  ʊ: 'u',
  ɯ: 'u',
  ɤ: 'o',
  ʌ: 'a',
  y: 'y',
  ʏ: 'y',
  ø: 'oe',
  œ: 'oe',
  ɶ: 'oe',
  ə: 'e',
  ɜ: 'e',
  ɞ: 'o',
  // Pulmonic consonants.
  b: 'b',
  d: 'd',
  ɖ: 'd',
  ʈ: 't',
  c: 'k',
  ɟ: 'g',
  ɡ: 'g',
  g: 'g',
  q: 'k',
  ɢ: 'g',
  ʔ: "'",
  ɸ: 'f',
  β: 'b',
  θ: 'th',
  ð: 'dh',
  ç: 'h',
  ʝ: 'y',
  x: 'kh',
  ɣ: 'gh',
  ħ: 'h',
  ʕ: 'h',
  ɦ: 'h',
  ɬ: 'lh',
  ɮ: 'lzh',
  ɧ: 'sh',
  ʜ: 'h',
  ʢ: 'h',
  ʡ: "'",
  dz: 'dz',
  dʑ: 'dzh',
  dʒ: 'dzh',
  f: 'f',
  h: 'h',
  j: 'y',
  k: 'k',
  l: 'l',
  m: 'm',
  ɱ: 'm',
  n: 'n',
  ɳ: 'n',
  ŋ: 'n',
  ɴ: 'n',
  p: 'p',
  ʙ: 'r',
  r: 'r',
  ʀ: 'r',
  ⱱ: 'r',
  ɾ: 'r',
  ɽ: 'r',
  ɺ: 'l',
  ɲ: 'ny',
  ɕ: 'sh',
  s: 's',
  t: 't',
  tɕ: 'ch',
  v: 'v',
  z: 'z',
  ʋ: 'v',
  ɹ: 'r',
  ɻ: 'r',
  ɰ: 'w',
  ɥ: 'y',
  w: 'w',
  ʃ: 'sh',
  ʂ: 'sh',
  ʒ: 'zh',
  ʐ: 'zh',
  ʑ: 'zh',
  ʍ: 'w',
  ɭ: 'l',
  ʎ: 'ly',
  ʟ: 'l',
  // Non-pulmonic consonants and common ligatures.
  ʘ: 'p',
  ǀ: 't',
  ǃ: 't',
  ǂ: 't',
  ǁ: 'l',
  ɓ: 'b',
  ɗ: 'd',
  ʄ: 'dzh',
  ɠ: 'g',
  ʛ: 'g',
  ʦ: 'ts',
  ʣ: 'dz',
  ʧ: 'ch',
  ʤ: 'dzh',
  ʨ: 'ch',
  ʥ: 'dzh',
  // Common modifiers.
  ʲ: 'y',
  ʷ: 'w',
  ˠ: 'gh',
  ˤ: 'h',
  ⁿ: 'n',
  '˞': 'r',
  ː: ':',
  ˑ: '.',
  ˀ: "'",
  ˁ: 'h',
  '˥': '5',
  '˦': '4',
  '˧': '3',
  '˨': '2',
  '˩': '1',
  ʁ: 'gh',
  χ: 'kh',
  ts: 'ts',
  tʃ: 'ch',
  'ˈ': "'",
  'ˌ': ',',
}

const MULTI_CHAR_KEYS = Object.keys(IPA_TO_LATIN)
  .filter((key) => key.length > 1)
  .sort((a, b) => b.length - a.length)

function normalizeIpa(ipa: string): string {
  return ipa
    .replace(/[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\u2de0-\u2dff\ufe20-\ufe2f\u200dʰʱ]/g, '')
    .toLowerCase()
}

function uppercaseFirst(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export function ipaLatin(ipa: string): string {
  const uppercase = ipa.length > 0 && ipa[0] !== ipa[0].toLowerCase()
  const normalized = normalizeIpa(ipa)
  let result = ''
  let i = 0
  while (i < normalized.length) {
    const ch = normalized[i]
    let matched = false
    for (const key of MULTI_CHAR_KEYS) {
      if (normalized.startsWith(key, i)) {
        result += IPA_TO_LATIN[key]
        i += key.length
        matched = true
        break
      }
    }
    if (matched) continue
    if (IPA_TO_LATIN[ch]) {
      result += IPA_TO_LATIN[ch]
      i++
      continue
    }
    result += ch
    i++
  }
  return uppercase ? uppercaseFirst(result) : result
}
